// extracted by mini-css-extract-plugin
module.exports = {"container":"prev-next_container__rirDu"};